// Objective waypoint: a gold beacon in ship space marking where the current
// captain's order wants you, drawn through the steel (depthTest off), plus a
// screen-space chip with the objective name and range that clamps to the
// viewport edge and grows a direction arrow when the beacon is off screen.

import * as THREE from "three";

export class Waypoint {
  constructor(G) {
    this.G = G;
    this.anchor = null;   // THREE.Vector3, ship-local walk position
    this.label = "";
    this.el = document.getElementById("bb-way");
    this.arrowEl = document.getElementById("bb-way-arrow");
    this.textEl = document.getElementById("bb-way-text");

    const gold = 0xffcf5c;
    this.group = new THREE.Group();
    this.diamond = new THREE.Mesh(
      new THREE.OctahedronGeometry(0.5),
      new THREE.MeshBasicMaterial({ color: gold, transparent: true, opacity: 0.85, depthTest: false, depthWrite: false }));
    this.diamond.renderOrder = 990;
    this.beam = new THREE.Mesh(
      new THREE.CylinderGeometry(0.10, 0.32, 24, 6, 1, true),
      new THREE.MeshBasicMaterial({ color: gold, transparent: true, opacity: 0.14, depthTest: false, depthWrite: false, side: THREE.DoubleSide }));
    this.beam.position.y = 12;
    this.beam.renderOrder = 989;
    this.group.add(this.diamond, this.beam);
    this.group.visible = false;
    G.shipInner.add(this.group);

    this.t = 0;
    this._w = new THREE.Vector3();
    this._v = new THREE.Vector3();
  }

  set(anchor, label) {
    if (!anchor) {
      this.anchor = null;
      this.group.visible = false;
      this.el.classList.add("hidden");
      return;
    }
    if (!this.anchor || !this.anchor.equals(anchor)) {
      this.anchor = anchor.clone();
      this.group.position.copy(anchor);
    }
    this.label = label || "OBJECTIVE";
  }

  update(dt) {
    const G = this.G;
    if (!this.anchor || G.over || G.stations.active || G.hud.tpOpen || G.shellCam?.on) {
      this.group.visible = false;
      this.el.classList.add("hidden");
      return;
    }
    this.t += dt;
    const d = G.player.pos.distanceTo(this.anchor);
    if (d < 3.2) { // you're here
      this.group.visible = false;
      this.el.classList.add("hidden");
      return;
    }
    this.group.visible = true;
    this.diamond.rotation.y += dt * 1.6;
    this.diamond.position.y = 1.9 + Math.sin(this.t * 2.4) * 0.22;

    // project the beacon to the screen
    const w = this._w.copy(this.anchor);
    w.y += 1.9;
    G.shipInner.localToWorld(w);
    const v = this._v.copy(w).applyMatrix4(G.camera.matrixWorldInverse);
    const behind = v.z > -0.1;
    w.project(G.camera);
    let sx = (w.x * 0.5 + 0.5) * window.innerWidth;
    let sy = (-w.y * 0.5 + 0.5) * window.innerHeight;
    if (behind) { sx = window.innerWidth - sx; sy = window.innerHeight - 40; }
    const mx = 70, my = 56;
    const cx = Math.max(mx, Math.min(window.innerWidth - mx, sx));
    const cy = Math.max(my, Math.min(window.innerHeight - my, sy));
    const off = behind || cx !== sx || cy !== sy;

    this.el.classList.remove("hidden");
    this.el.style.left = `${cx}px`;
    this.el.style.top = `${cy}px`;
    this.textEl.textContent = `${this.label} — ${Math.round(d)} m`;
    if (off) {
      const ang = Math.atan2(sy - cy, sx - cx);
      this.arrowEl.classList.remove("hidden");
      this.arrowEl.style.transform = `rotate(${ang}rad)`;
    } else {
      this.arrowEl.classList.add("hidden");
    }
  }
}
